import { createApiHook, useApi } from "../utils/apiUtils";

const useGetUser = () => {
  const { apiGet } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const getUser = async ({ email }) => {
    startLoading();
    const response = await apiGet("/users/show", "Error al obtener el usuario", { email });
    setResponse(response);
  };

  return { getUser, data, loading, error };
};

export default useGetUser;
